import {getWithAuth} from '@/api/base/authorised-requests'
import {CompanyInfoResponse, CompanySearchResponse, ONBOARDING_BASE_URL} from '@/stores/onboarding'

/**
 * Searches for companies by name
 * @param name Company name to search for
 * @returns Search results with matching companies
 */
export const fetchCompanyByName = async (name: string): Promise<CompanySearchResponse> => {
    try {
        const response = await getWithAuth<any>(
            `${ONBOARDING_BASE_URL}/company?name=${encodeURIComponent(name)}`
        )

        if (Array.isArray(response.result)) {
            return {items: response.result}
        }

        if (response.result?.items && Array.isArray(response.result.items)) {
            return response.result
        }

        return {items: []}
    } catch (error: any) {
        return {items: []}
    }
}

/**
 * Gets detailed information for a specific company
 * @param companyId Company ID/Number to look up
 * @returns Company information details
 */
export const fetchCompanyInfo = async (companyId: string): Promise<CompanyInfoResponse> => {
    try {
        const response = await getWithAuth<any>(`${ONBOARDING_BASE_URL}/company/id/${companyId}`)

        return response.result
    } catch (error) {
        throw error
    }
}
